// Static placeholder data for Phoenix Dance Academy

export const BRANCHES = [
  {
    id: "india",
    name: "India",
    code: "IN",
    city: "Chennai",
    phone: "+91 82482 14953",
    whatsapp: "918248214953",
    altWhatsapp: "918122126994",
    altPhone: "+91 81221 26994",
    email: "phoenixacademy2506@gmail.com",
    flag: "🇮🇳",
    timezone: "IST",
    region: "South India · Asia Pacific",
    locations: [
      {
        id: "chennai-main",
        name: "Main Branch — Vyasarpadi",
        address: "No.267, MKB Nagar, Vyasarpadi, Chennai 600039",
        phone: "+91 82482 14953",
        instagram: "phoenix_dance_academy_pda",
      },
    ],
  },
  {
    id: "usa",
    name: "USA",
    code: "US",
    city: "Sacramento",
    phone: "+1 904 807 8000",
    whatsapp: "19048078000",
    email: "phoenixacademy2506@gmail.com",
    flag: "🇺🇸",
    timezone: "PST",
    region: "Northern California · West Coast USA",
    locations: [
      {
        id: "sacramento-main",
        name: "Sacramento Studio",
        address: "4168 Azul Way, Sacramento, CA 95835",
        instagram: "phoenixdanceacademyinusa",
      },
    ],
  },
  {
    id: "canada",
    name: "Canada",
    code: "CA",
    city: "Kitchener",
    phone: "+1 647 898 2549",
    whatsapp: "16478982549",
    email: "phoenixacademy2506@gmail.com",
    flag: "🇨🇦",
    timezone: "EST",
    region: "Waterloo Region · Ontario, Canada",
    locations: [
      {
        id: "kitchener-main",
        name: "Kitchener Studio",
        address: "37 Eliza Ave, Kitchener, N2E 0G2, Ontario",
        phone: "+1 647 898 2549",
        instagram: "phoenixdanceacademycanada",
      },
    ],
  },
];

export const STATS = [
  { value: 10000, suffix: "+", label: "Students Trained" },
  { value: 420, suffix: "+", label: "Workshops Conducted" },
  { value: 260, suffix: "+", label: "Stage Performances" },
  { value: 78, suffix: "", label: "Certified Instructors" },
  { value: 8, suffix: "", label: "Countries Toured" },
  { value: 3, suffix: "", label: "Countries Based In" },
];

export const PROGRAMS = [
  {
    slug: "kids",
    title: "Kids Dance Program",
    age: "Ages 4–12",
    level: "All levels",
    description: "Playful, imaginative classes that build coordination, confidence, and a love for movement.",
    image: "/programs/pda-emblem.jpg",
    span: "lg:col-span-5",
  },
  {
    slug: "beginner",
    title: "Beginner Dance",
    age: "Teens & Adults",
    level: "Beginner",
    description: "Foundations of rhythm, posture, and choreography across multiple styles. No experience needed.",
    image: "/programs/pda-emblem.jpg",
    span: "lg:col-span-7",
  },
  {
    slug: "advanced",
    title: "Intermediate / Advanced Training",
    age: "All ages",
    level: "Intermediate · Advanced",
    description: "Technique-driven programs with structured syllabus, performance prep, and competition pathways.",
    image: "/programs/pda-emblem.jpg",
    span: "lg:col-span-7",
  },
  {
    slug: "choreo",
    title: "Professional Crew / Performers",
    age: "14+",
    level: "Intermediate · Advanced",
    description: "Build original pieces with mentorship from industry choreographers. From concept to stage.",
    image: "/programs/pda-emblem.jpg",
    span: "lg:col-span-5",
  },
  {
    slug: "fitness",
    title: "Dance Fitness",
    age: "16+",
    level: "All levels",
    description: "High-energy cardio choreography blending hip-hop, Bollywood, and Afro for full-body conditioning.",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1200",
    span: "lg:col-span-4",
  },
  {
    slug: "private",
    title: "Private 1-on-1 Coaching",
    age: "All ages",
    level: "Personalised",
    description: "Tailored sessions for auditions, weddings, performances, and rapid skill acceleration.",
    image: "https://images.unsplash.com/photo-1518609571773-39b7d303a87b?w=1200",
    span: "lg:col-span-4",
  },
  {
    slug: "online",
    title: "Online Classes",
    age: "All ages",
    level: "Beginner to Advanced",
    description: "Live and on-demand classes from anywhere — same Phoenix faculty, your living room.",
    image: "https://images.unsplash.com/photo-1602827114685-efbb2717da9f?w=1200",
    span: "lg:col-span-4",
  },
  {
    slug: "wedding",
    title: "Wedding Choreography",
    age: "Couples & Families",
    level: "Custom",
    description: "Sangeet, first dance, and family routines crafted to your story — rehearsals at our studios or yours.",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1200",
    span: "lg:col-span-12",
  },
];

export const WHY_PHOENIX = [
  { icon: "Award", title: "Expert Instructors", text: "Industry-certified faculty with global stage and screen credits." },
  { icon: "BookOpen", title: "Structured Syllabus", text: "Progressive levels with clear milestones from beginner to performer." },
  { icon: "Globe2", title: "International Community", text: "A global network of dancers across India, USA, and Canada." },
  { icon: "Sparkles", title: "Performance Opportunities", text: "Recitals, festivals, competitions, and brand showcases all year." },
  { icon: "Monitor", title: "Online + Offline", text: "Hybrid learning — train in-studio or live online, switch anytime." },
  { icon: "MapPin", title: "Multi-Country Presence", text: "Studios across three countries. One Phoenix family." },
];

export const DANCE_STYLES = [
  { name: "Hip-Hop", image: "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?w=800" },
  { name: "Contemporary", image: "https://images.pexels.com/photos/3022420/pexels-photo-3022420.jpeg?w=800" },
  { name: "Bollywood", image: "https://images.unsplash.com/photo-1535525153412-5a092d83a8c6?w=800" },
  { name: "Salsa", image: "https://images.unsplash.com/photo-1518609571773-39b7d303a87b?w=800" },
  { name: "Zumba", image: "https://images.unsplash.com/photo-1547153760-18fc86324498?w=800" },
  { name: "Afro", image: "https://images.unsplash.com/photo-1547153760-18fc86324498?w=800" },
  { name: "Freestyle", image: "https://images.pexels.com/photos/36763080/pexels-photo-36763080.jpeg?w=800" },
  { name: "Urban Choreo", image: "https://images.unsplash.com/photo-1690267717892-b88473bc771c?w=800" },
  { name: "Gymnastics", image: "https://images.pexels.com/photos/5888330/pexels-photo-5888330.jpeg?w=800" },
  { name: "Dance Fitness", image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800" },
];

export const FOUNDERS = [
  {
    id: "manikandan-g",
    name: "Manikandan Gopinath",
    role: "Founder & CEO",
    title: "Founder & CEO",
    branch: "India",
    city: "Chennai",
    flag: "🇮🇳",
    image: "https://customer-assets.emergentagent.com/job_phoenix-academy-1/artifacts/zk5iukyu_1000510498.png",
    instagram: "manikandanphoenix",
    phone: "+91 97911 11710",
    phone2: "+91 81221 26994",
    short:
      "Professional dancer, choreographer, and Vijay TV face. Specialised in freestyle, hip-hop, and contemporary — and one of Tamil Nadu's top contemporary dance performers.",
    bio:
      "Manikandan Gopinath is a professional dancer, choreographer, and instructor widely known from Vijay TV, specialising in freestyle, hip-hop, and contemporary — and recognised as one of Tamil Nadu's top contemporary dance performers. He has danced and choreographed across numerous reality shows, served as judge for corporate and college cultural events, and coached dancers who have gone on to win major TV competitions. His enthusiasm and drive have won him significant recognition — visible most clearly in his students' performances.\n\nHe founded Phoenix Dance Academy in Chennai in 2014, starting with just three students. Today PDA is a multinational dance institution with branches across India (Chennai), the USA, and Canada — and has trained over 10,000 students.\n\nIn the USA, Manikandan personally trains 100+ students from 5-year-olds to adults across the Sacramento community. In Canada, he leads classes for 50+ students performing across Ontario's Indian community events.",
    quote: "Dance is discipline disguised as joy. We teach both.",
    experience: "18+ years",
    specialties: ["Freestyle", "Hip-Hop", "Contemporary", "Choreography"],
    professionalStrengths: [
      "International choreography & performance direction",
      "Large-scale team training and mentoring",
      "Cross-cultural artistic collaboration",
      "Event choreography and stage production",
      "Proven track record in competition success",
    ],
    achievements: [
      "Founded Phoenix Dance Academy (Chennai · 2014) — grew from 3 students to 10,000+ trained",
      "Established branches across India, USA, and Canada — building a multinational dance institution",
      "Trains 100+ students in the USA and 50+ students in Canada personally",
      "Vijay TV recognised choreographer and on-screen presence",
      "One of Tamil Nadu's top contemporary dance performers",
      "Coached dancers to victory in televised dance competitions",
      "Judge for corporate events, college festivals, and international conventions",
      "International masterclass instructor across Thailand, Singapore, Malaysia, Dubai, and the USA",
    ],
    education: [
      "Two decades of formal training across freestyle, hip-hop, and contemporary disciplines",
      "Continuous professional development through televised work, choreography commissions, and global workshops",
    ],
    realityShows: [
      { show: "Jodi No.1 — Season 4 & 5", role: "Assistant Choreographer", channel: "Vijay TV", year: "2012" },
      { show: "Ungalil Yaar Adutha Prabhudeva", role: "Top Contestant", channel: "Vijay TV", year: "2013" },
      { show: "Kings of Dance", role: "Semi-Finalist & Choreographer", channel: "Vijay TV", year: "2017" },
      { show: "Dancing Super Stars (Jill Jung Juck Team)", role: "Finalist · Choreographer", channel: "Vijay TV", year: "2019" },
      { show: "Odi Vilayadu Papa", role: "Choreographer", channel: "Kalaignar TV", year: "2010" },
      { show: "Little Super Dancer", role: "Choreographer", channel: "Jaya TV", year: "2011" },
      { show: "Nach Baliye", role: "Hindi appearance", channel: "Star Plus", year: "2013" },
    ],
    liveEvents: [
      { title: "Hyundai Product Launch", location: "Chennai", role: "Choreographer" },
      { title: "Ulaganayagan Kamal Sir Birthday Celebration", location: "Vijay TV", role: "Co-Choreographer" },
    ],
    movieLaunches: [
      "Master",
      "Don",
      "Naai Sekar",
      "Prince",
      "Vaathi",
      "Kaanguva",
    ],
    albumChoreography: [
      { title: "Dad's Princess", year: "2025" },
      { title: "Nandhi Mark", year: "2018" },
    ],
    overseasWorkshops: [
      { country: "Thailand", date: "Feb 2023" },
      { country: "Singapore", date: "Feb 2024" },
      { country: "Malaysia", date: "Feb 2024" },
      { country: "Dubai (UAE)", date: "Mar 2024" },
      { country: "USA — California & Texas", date: "Jun & Jul 2024" },
    ],
  },
  {
    id: "gowri-s",
    name: "Gowri Sathish",
    role: "Co-Founder · Creative Director",
    title: "Co-Founder · Choreographer · Creative Director · PDA USA",
    branch: "USA",
    city: "Sacramento",
    flag: "🇺🇸",
    image: "https://customer-assets.emergentagent.com/job_6cca8547-737d-493e-b727-f6f20e12f6aa/artifacts/3uubl2r1_WhatsApp%20Image%202026-05-18%20at%2011.49.36.jpeg",
    instagram: "_ishwri_",
    phone: "+1 904 807 8000",
    short:
      "Co-Founder, Choreographer & Creative Director of Phoenix Dance Academy USA. Indo-Western specialist shaping the Sacramento dance community.",
    bio:
      "Gowri Sathish is the Co-Founder, Instructor, Choreographer, and Creative Director of Phoenix Dance Academy USA. A passionate and versatile Indo-Western dancer, she has been teaching and choreographing performances for students of all ages across Sacramento and surrounding areas.\n\nKnown for her energetic, stylish, performance-oriented choreography rooted in strong technical foundations, Gowri has trained and mentored hundreds of students through both online and in-person classes — helping dancers build confidence, stage presence, coordination, and a lifelong love for dance in a fun, encouraging environment.\n\nUnder her creative direction, Phoenix Dance Academy USA has become widely recognized for its creative choreography, professional productions, and energetic stage performances. Her students have performed at major cultural events, competitions, school programs, and community festivals across California — earning multiple awards and recognitions along the way.",
    quote: "Confidence, creativity, discipline, passion — that's what dance gives every student.",
    experience: "10+ years",
    specialties: ["Bollywood", "Hip Hop", "Indian Cinematic", "Contemporary Fusion", "Folk", "Dance Fitness"],
    professionalStrengths: [
      "Certified Zumba Instructor",
      "Vocal & Veena Teacher",
      "Parai Player",
      "QA Engineer by profession",
      "Mom of a Tween & a beloved dog",
    ],
    achievements: [
      "Co-Founded Phoenix Dance Academy USA — Sacramento, 2021",
      "Trained & mentored hundreds of students across online and in-person programs",
      "Choreographed award-winning performances at USA Got Talent — Bay Area and Sargolsav Dance Competition",
      "Collaborated with leading cultural associations across California for community productions",
      "Built PDA USA's signature Indo-Western curriculum & youth performance teams",
      "Frequent stage presence at festivals, school programs, and community events across the USA",
    ],
    education: [
      "Decade-long performing & choreography practice across Indo-Western styles",
      "Certified Zumba Instructor — fitness-grade dance training",
      "Trained in Indian classical music — Vocal & Veena",
      "Traditional Parai percussion practitioner",
      "Continuous mentorship under PDA founder Manikandan Gopinath",
    ],
  },
  {
    id: "sandhya-r",
    name: "Sandhya Vijayakumar",
    role: "Co-Founder · Canada",
    title: "Co-Founder · Choreographer · Creative Director · PDA Canada",
    branch: "Canada",
    city: "Kitchener",
    flag: "🇨🇦",
    image: "/founders/sandhya.jpg",
    instagram: "sandy_s2_sinamika",
    phone: "+1 647 898 2549",
    short:
      "Co-Founder & Creative Director of Phoenix Dance Academy Canada. Software QA Analyst by profession, choreographer at heart — building Kitchener's growing Indo-Canadian dance community.",
    bio:
      "By profession, Sandhya is a Software Quality Assurance Analyst — but her heart belongs to the world of dance, choreography, and inspiring others through movement. She is passionate about teaching Indian Cinematic, Indian Folk, Contemporary, and Hip-Hop to all age groups — Kids, Teens, and Adults — always striving to create a positive, energetic, and comfortable environment where everyone can learn, enjoy, and express themselves through dance.\n\nShe restarted her dance passion under the guidance of her Master, celebrity choreographer Manikandan Gopinath — a finalist from a popular Vijay TV reality show. After learning through his online classes, in 2025 she collaborated with Master Manikandan and opened the franchise of Phoenix Dance Academy in Kitchener, Ontario — running regular classes and choreographing for weddings, live music events, competitions, and baby showers.\n\nThe journey started with just 3 kindergarten kids. Through consistent hard work, dedication, and her love for teaching, the academy has grown to 25+ active students within one year — and continues to expand across Kitchener's South-Asian community.\n\nBeyond Dance — Cricket fuels my discipline, focus, and team spirit. On the field or the dance floor, I believe in giving my best and inspiring others to do the same.",
    quote: "Dance is for everyone — empowering kids, teens, men, and women of all ages to overcome hesitation and rediscover themselves through movement.",
    experience: "7+ years",
    specialties: ["Indian Cinematic", "Indian Folk", "Contemporary", "Hip-Hop"],
    professionalStrengths: [
      "Software Quality Assurance Analyst by profession",
      "Trained under celebrity choreographer Manikandan Gopinath",
      "Wedding & event choreographer across Ontario",
      "Builds inclusive, beginner-friendly dance spaces",
    ],
    achievements: [
      "Founded Phoenix Dance Academy Canada — Kitchener, Ontario (2025)",
      "Grew from 3 kindergarten kids to 25+ active students within one year",
      "Choreographed and won 2nd prize at Gala Competition, Ontario",
      "Performed and choreographed across 16+ major cultural events in Ontario",
      "Regular choreographer for weddings, live music events, baby showers, and competitions",
    ],
    education: [
      "Trained in Indian Cinematic, Indian Folk, Contemporary, and Hip-Hop",
      "Continuing online mentorship under Manikandan Gopinath (PDA Founder & CEO)",
      "Background in Software Quality Assurance — bringing structure and precision to dance pedagogy",
    ],
  },
];

// Pure dance instructors (photo + name + style only)
export const FACULTY = [
  {
    id: "dinesh-v",
    name: "Dinesh Venkatesan",
    role: "Dancer · Choreographer · Dance Master",
    qualification: "MBA HRM Graduate",
    branch: "India",
    instagram: "dinasaran49",
    styles: ["Hip Hop", "Locking", "House", "Popping", "Waacking", "Cinematic Folk", "Freestyle"],
    years: 10,
    image:
      "https://customer-assets.emergentagent.com/job_6cca8547-737d-493e-b727-f6f20e12f6aa/artifacts/l5j93cti_WhatsApp%20Image%202026-05-18%20at%2020.41.40.jpeg",
    short:
      "Nearly a decade of stage and television experience — specialised in Hip Hop, Locking, House, Popping, Waacking, Cinematic Folk, and Freestyle.",
    bio:
      "Dinesh Venkatesan is a multidisciplinary dancer, choreographer, and dance master with nearly 10 years of experience across stage productions, television choreography, and academy training.\n\nAn MBA HRM graduate, Dinesh brings both creative flair and structured discipline to every class — guiding students through the urban dance vocabulary while preserving the storytelling roots of Indian cinematic and folk forms.\n\nHe has choreographed and assisted on some of Tamil Nadu's most-watched dance shows and continues to train and perform with multiple academies across Chennai.",
    showCredits: [
      { role: "Choreographer", show: "Odi Vilaiyadu Papa", channel: "Kalaignar TV" },
      { role: "Assistant Choreographer", show: "Kings of Dance — Season 1", channel: "Vijay TV" },
      { role: "Assistant Choreographer", show: "Dancing Super Stars", channel: "Vijay TV" },
      { role: "Assistant Choreographer", show: "Bigg Boss Jodigal — Season 1", channel: "Vijay TV" },
    ],
    workedWith: [
      "Phoenix Dance Academy",
      "Just Step In Dance Studio",
      "Flash Feet Dance Academy",
    ],
  },
  {
    id: "rajkumar-r",
    name: "Rajkumar",
    role: "Choreographer · Director · Performing Artist",
    branch: "India",
    instagram: "rajchoreo_",
    styles: ["Stage Choreography", "Direction", "Screen Performance", "Content Creation", "Dance Training"],
    years: 7,
    studentsTrained: "500+",
    image:
      "https://customer-assets.emergentagent.com/job_6cca8547-737d-493e-b727-f6f20e12f6aa/artifacts/rt04vm4o_WhatsApp%20Image%202026-05-18%20at%2021.08.46.jpeg",
    short:
      "Multidisciplinary creative — choreographer, director, and performing artist with several years across stage, screen, and academy training.",
    bio:
      "Rajkumar is a multidisciplinary creative — choreographer, director, and performing artist — with several years of experience across stage productions, screen direction, and dance education.\n\nHe currently serves as Assistant Choreographer at Phoenix Dance Academy under the mentorship of Manikanda G — Vijay TV choreographer and PDA founder. As Dance Master & Instructor, he teaches across multiple academies in Chennai, having trained and mentored 500+ students in technical dance skills and live stage performance.\n\nBeyond the studio, Rajkumar works as a freelance choreographer for school and college cultural events, corporate shows, music albums, and live stage performances — and directs and performs in independent music albums, short films, and digital content.",
    workedWith: [
      "Phoenix Dance Academy",
      "R3 Dance Studio",
      "Sree Ruby Chithuraj Academy",
    ],
    freelanceFor: [
      "School & College Cultural Events",
      "Corporate Shows",
      "Music Albums",
      "Live Stage Performances",
    ],
    directorFor: [
      "Independent Music Albums",
      "Short Films",
      "Digital Content",
    ],
  },
  {
    id: "santoskumar-s",
    name: "Santoskumar Senthilkumar",
    role: "Web Designer & Manager",
    branch: "India",
    instagram: "santos_senthil",
    nonTeaching: true,
    imagePosition: "object-top",
    styles: [
      "Web Design",
      "UI/UX",
      "Landing Page Development",
      "Website Management",
      "Performance Optimization",
      "Digital Branding",
      "Client Coordination",
    ],
    years: 3,
    image: "/faculty/santoskumar.jpg",
    short:
      "Creative web professional with 3+ years of experience in website design, development, and digital management — building modern, responsive, user-friendly experiences that strengthen brand identity.",
    bio:
      "Santoskumar Senthilkumar is a creative and passionate web professional with 3+ years of experience in website design, development, and digital management. He specialises in creating modern, responsive, and user-friendly websites that strengthen brand identity and improve online presence.\n\nHe is skilled in website management, UI/UX design, content updates, performance optimization, and maintaining seamless digital experiences for clients and businesses — focused on delivering visually appealing and functional web solutions tailored to each client's requirements.\n\nExperienced in collaborating with creative teams, managing website operations, and supporting businesses with professional digital branding and online growth strategies. Santoskumar combines creativity, technical expertise, and strategic thinking to build engaging digital experiences — dedicated to helping brands establish a strong online presence through clean design, efficient management, and innovative web solutions.",
    workedWith: [
      "Phoenix Dance Academy",
    ],
  },
  {
    id: "rinku",
    name: "Rinku Sharma",
    role: "Admin",
    branch: "India",
    styles: ["Operations", "Coordination", "Student Relations"],
    years: 5,
    image: "/faculty/rinku.jpg",
    imagePosition: "object-top",
    short: "Phoenix Dance Academy Administrator.",
    noProfile: true,
  },
];
// Backward-compat alias for older imports
export const DANCE_INSTRUCTORS = FACULTY;

export const INSTRUCTORS = [
  {
    id: "manikandan-g",
    name: "Manikandan Gopinath",
    role: "Founder · Artistic Director",
    branch: "India",
    styles: ["Freestyle", "Hip-Hop", "Contemporary", "Choreography"],
    years: 18,
    image: "https://customer-assets.emergentagent.com/job_phoenix-academy-1/artifacts/zk5iukyu_1000510498.png",
    bio: "Founder & CEO of Phoenix Dance Academy. Vijay TV choreographer specialising in freestyle, hip-hop, and contemporary.",
  },
  {
    id: "gowri-s",
    name: "Gowri Sathish",
    role: "Founder · USA Branch",
    branch: "USA",
    styles: ["Contemporary", "Bollywood", "Performance"],
    years: 14,
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800",
    bio: "Founder of Phoenix Sacramento. Choreographer, performer, and curriculum lead for the USA branch.",
  },
  {
    id: "sandhya-r",
    name: "Sandhya Vijayakumar",
    role: "Co-Founder · Canada Branch",
    branch: "Canada",
    styles: ["Indian Cinematic", "Folk", "Contemporary", "Hip-Hop"],
    years: 1,
    image: "/founders/sandhya.jpg",
    bio: "Co-Founder of Phoenix Kitchener and Creative Director of our Canadian programs.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Aanya M.",
    role: "Student · Chennai",
    quote: "Phoenix gave me the stage and the discipline to chase dance seriously. The faculty pushes you with so much love.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400",
  },
  {
    name: "David & Priya",
    role: "Wedding clients · Sacramento",
    quote: "Our sangeet was unforgettable. They choreographed for both families and made the entire process joyful.",
    image: "https://images.unsplash.com/photo-1525357352208-c95b3d8b1ad1?w=400",
  },
  {
    name: "Mira S.",
    role: "Parent · Kitchener",
    quote: "My daughter went from shy to absolutely radiant on stage. The kids program is world-class.",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400",
  },
  {
    name: "Jordan K.",
    role: "Adult beginner · Sacramento",
    quote: "I started at 32 with zero experience. Six months later I performed at a Phoenix showcase. Surreal.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400",
  },
];

export const GALLERY = [
  { src: "https://images.pexels.com/photos/3022420/pexels-photo-3022420.jpeg?w=1200", category: "Performance" },
  { src: "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?w=1200", category: "Class" },
  { src: "https://images.pexels.com/photos/36763080/pexels-photo-36763080.jpeg?w=1200", category: "Performance" },
  { src: "https://images.pexels.com/photos/5888330/pexels-photo-5888330.jpeg?w=1200", category: "Kids" },
  { src: "https://images.unsplash.com/photo-1690267717892-b88473bc771c?w=1200", category: "Rehearsal" },
  { src: "https://images.unsplash.com/photo-1535525153412-5a092d83a8c6?w=1200", category: "Performance" },
  { src: "https://images.unsplash.com/photo-1547153760-18fc86324498?w=1200", category: "Class" },
  { src: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1200", category: "Fitness" },
  { src: "https://images.unsplash.com/photo-1518609571773-39b7d303a87b?w=1200", category: "Workshop" },
  { src: "https://images.unsplash.com/photo-1602827114685-efbb2717da9f?w=1200", category: "Class" },
];

export const CLASSES = [
  // ============== USA — IN-PERSON ==============
  { id: "usa-inp-toddlers", title: "Toddler All-Style Dance", style: "All Style", level: "All level", age: "Toddlers (2.5–5)", ageBand: "Toddlers", branch: "USA", mode: "Offline", schedule: "Mon · 5:30–6:15 PM PST", duration: "45 min" },
  { id: "usa-inp-kids", title: "Kids All-Style Dance", style: "All Style", level: "All level", age: "Kids (5–8)", ageBand: "Kids", branch: "USA", mode: "Offline", schedule: "Wed · 6:00–7:00 PM PST", duration: "1 hr" },
  { id: "usa-inp-juniors", title: "Juniors All-Style Dance", style: "All Style", level: "All level", age: "Juniors (9–12)", ageBand: "Juniors", branch: "USA", mode: "Offline", schedule: "Wed · 7:00–8:00 PM PST", duration: "1 hr" },
  { id: "usa-inp-adults-fitness", title: "Dance & Fitness", style: "Dance Fitness", level: "All level", age: "Adults (18+)", ageBand: "Adults", branch: "USA", mode: "Offline", schedule: "Tue · 6:30–7:30 PM PST", duration: "1 hr" },
  { id: "usa-inp-bhangra", title: "Bhangra", style: "Bhangra", level: "Beginner", age: "Ages 6+", ageBand: "All ages", branch: "USA", mode: "Offline", schedule: "Sun · 6:00–7:00 PM PST", duration: "1 hr" },

  // ============== USA — ONLINE ==============
  { id: "usa-on-kids", title: "Kids All-Style Dance", style: "All Style", level: "Beginner", age: "Kids (5–9)", ageBand: "Kids", branch: "USA", mode: "Online", schedule: "Tue & Thu · 5:30–6:30 PM PST", duration: "1 hr" },
  { id: "usa-on-teens", title: "Teens & Adults All-Style Dance", style: "All Style", level: "Intermediate", age: "Teens & Adults (11+)", ageBand: "Teens", branch: "USA", mode: "Online", schedule: "Mon & Wed · 5:30–6:30 PM PST", duration: "1 hr" },
  { id: "usa-on-juniors", title: "Juniors All-Style Dance", style: "All Style", level: "Advanced", age: "Juniors (10–13)", ageBand: "Juniors", branch: "USA", mode: "Online", schedule: "Tue & Thu · 7:00–8:00 PM PST", duration: "1 hr" },
  { id: "usa-on-pro", title: "Professional All-Style Dance", style: "All Style", level: "Professional", age: "Teens & Adults (13+)", ageBand: "Teens", branch: "USA", mode: "Online", schedule: "Tue & Thu · 8:30–9:30 PM PST", duration: "1 hr", note: "3 years dance experience required" },

  // ============== INDIA — GYMNASTICS ==============
  { id: "ind-inp-gym-beg", title: "Gymnastics — Beginner", style: "Gymnastics", level: "Beginner", age: "Any age", ageBand: "All ages", branch: "India", mode: "Offline", schedule: "Thu & Fri · 5:00–6:00 PM IST", duration: "1 hr" },
  { id: "ind-inp-gym-int", title: "Gymnastics — Intermediate", style: "Gymnastics", level: "Intermediate", age: "Any age", ageBand: "All ages", branch: "India", mode: "Offline", schedule: "Thu & Fri · 6:00–7:00 PM IST", duration: "1 hr" },
  { id: "ind-inp-gym-adv", title: "Gymnastics — Advanced", style: "Gymnastics", level: "Advanced", age: "Any age", ageBand: "All ages", branch: "India", mode: "Offline", schedule: "Thu & Fri · 7:00–8:00 PM IST", duration: "1 hr" },
  { id: "ind-inp-gym-pro", title: "Gymnastics — Professional", style: "Gymnastics", level: "Professional", age: "Any age", ageBand: "All ages", branch: "India", mode: "Offline", schedule: "Thu & Fri · 8:00–9:00 PM IST", duration: "1 hr" },

  // ============== INDIA — ALL STYLE DANCE ==============
  { id: "ind-inp-prekids", title: "Pre-Kids All-Style Dance", style: "All Style", level: "Beginner", age: "Ages 4–6", ageBand: "Kids", branch: "India", mode: "Offline", schedule: "Sat 4–5 PM · Sun 10–11 AM IST", duration: "1 hr" },
  { id: "ind-inp-kids", title: "Kids All-Style Dance", style: "All Style", level: "Beginner", age: "Ages 7–10", ageBand: "Kids", branch: "India", mode: "Offline", schedule: "Sat 5–6 PM · Sun 11–12 PM IST", duration: "1 hr" },
  { id: "ind-inp-juniors", title: "Juniors All-Style Dance", style: "All Style", level: "Intermediate", age: "Ages 11–13", ageBand: "Juniors", branch: "India", mode: "Offline", schedule: "Sat 6–7 PM · Sun 12–1 PM IST", duration: "1 hr" },
  { id: "ind-inp-teens", title: "Teens & Adults All-Style Dance", style: "All Style", level: "Advanced", age: "Ages 14+", ageBand: "Teens", branch: "India", mode: "Offline", schedule: "Sat 7–8 PM · Sun 1–2 PM IST", duration: "1 hr" },
  { id: "ind-inp-pro", title: "Professional All-Style Dance", style: "All Style", level: "Professional", age: "All ages", ageBand: "All ages", branch: "India", mode: "Offline", schedule: "Sat 8–9 PM · Sun 2–3 PM IST", duration: "1 hr", note: "3 years dance experience required" },
  { id: "ind-inp-women", title: "Women's Adults All-Style Dance", style: "All Style", level: "Intermediate", age: "Adults (18+) · Women only", ageBand: "Adults", branch: "India", mode: "Offline", schedule: "Sat 3–4 PM · Sun 3–4 PM IST", duration: "1 hr" },

  // ============== INDIA — CLASSICAL ==============
  { id: "ind-inp-classical", title: "Classical Dance", style: "Classical", level: "Beginner", age: "Any age", ageBand: "All ages", branch: "India", mode: "Offline", schedule: "Mon & Tue · 5:00–6:00 PM IST", duration: "1 hr" },

  // ============== INDIA — BOLLYWOOD ==============
  { id: "ind-inp-bolly-kids", title: "Bollywood — Kids", style: "Bollywood", level: "Beginner", age: "Ages 6–10", ageBand: "Kids", branch: "India", mode: "Offline", schedule: "Mon & Tue · 6:00–7:00 PM IST", duration: "1 hr" },
  { id: "ind-inp-bolly-jr", title: "Bollywood — Juniors", style: "Bollywood", level: "Intermediate", age: "Ages 10–13", ageBand: "Juniors", branch: "India", mode: "Offline", schedule: "Mon & Tue · 7:00–8:00 PM IST", duration: "1 hr" },

  // ============== CANADA — ONLINE ==============
  { id: "can-on-juniors", title: "Juniors All-Style Dance", style: "All Style", level: "Intermediate", age: "Ages 8–12", ageBand: "Juniors", branch: "Canada", mode: "Online", schedule: "Tue 7–8 PM · Sun 10–11 AM EST", duration: "1 hr" },
  { id: "can-on-pro", title: "Professional All-Style Dance", style: "All Style", level: "Professional", age: "Teens & Adults (13+)", ageBand: "Teens", branch: "Canada", mode: "Online", schedule: "Thu 7–8 PM · Sun 11:30–12:30 PM EST", duration: "1 hr", note: "3 years dance experience required" },

  // ============== CANADA — IN-PERSON ==============
  { id: "can-inp-teens", title: "Teens All-Style Dance", style: "All Style", level: "All level", age: "Teens (13–17)", ageBand: "Teens", branch: "Canada", mode: "Offline", schedule: "Tue · 5:30–6:30 PM EST", duration: "1 hr" },
  { id: "can-inp-women", title: "Women's Adults All-Style Dance", style: "All Style", level: "All level", age: "Adults (18+) · Women only", ageBand: "Adults", branch: "Canada", mode: "Offline", schedule: "Mon · 6:30–7:30 PM EST", duration: "1 hr" },
  { id: "can-inp-kids", title: "Kids All-Style Dance", style: "All Style", level: "All level", age: "Kids (5–8)", ageBand: "Kids", branch: "Canada", mode: "Offline", schedule: "Fri · 5:30–6:30 PM EST", duration: "1 hr" },
];

export const SERVICES = [
  { title: "Event Choreography", desc: "Concerts, brand launches, award nights — original choreography from concept to stage.", icon: "Sparkles" },
  { title: "Wedding Choreography", desc: "Sangeet, first dance, and full-family productions tailored to your story.", icon: "Heart" },
  { title: "Album Choreography", desc: "Independent music videos and single-song productions — choreography, direction, and on-set execution.", icon: "Disc" },
  { title: "Product Launch Events", desc: "Headline performances and stage choreography for brand and product launches.", icon: "Rocket" },
  { title: "Advertisement Choreography", desc: "Commercial-grade movement direction for TV spots, brand films, and digital ads.", icon: "Clapperboard" },
  { title: "Audio Launch Events", desc: "Movie audio launches and film promotional events — high-energy ensemble choreography.", icon: "Mic2" },
  { title: "Pre-Recorded Choreography", desc: "Custom routines delivered as polished video sessions — practice anywhere, anytime.", icon: "Video" },
  { title: "Corporate Performances", desc: "Showstopping performances and team-building dance experiences.", icon: "Briefcase" },
  { title: "School & College Choreo", desc: "Annual day, fests, and competition routines for institutions.", icon: "GraduationCap" },
  { title: "Private Mentoring", desc: "1-on-1 coaching for auditions, professional growth, or rapid skill jumps.", icon: "User" },
  { title: "Online Coaching", desc: "Global private coaching delivered live online with progress reviews.", icon: "Video" },
  { title: "Dance Fitness Programs", desc: "High-energy fitness modules for studios, gyms, and corporates.", icon: "Activity" },
  { title: "Studio Rentals", desc: "Premium dance floors and mirrored studios available across our branches.", icon: "Building2" },
  { title: "Judging & Workshops", desc: "Phoenix faculty available for judging panels, masterclasses, and intensives worldwide.", icon: "Star" },
];

export const FAQS = [
  { q: "Do you offer beginner classes?", a: "Yes — every program at Phoenix has a beginner pathway. No experience required, ever." },
  { q: "What age groups do you teach?", a: "We teach ages 4 through adult, with dedicated programs for kids, teens, and adults." },
  { q: "Are online classes available?", a: "Absolutely. We run live online classes and on-demand modules across all our programs." },
  { q: "Can I switch branches?", a: "Yes. Phoenix members can train at any of our branches across India, USA, and Canada." },
  { q: "Do you offer private lessons?", a: "We offer 1-on-1 private coaching both in-studio and online with our senior faculty." },
  { q: "Do you provide wedding choreography?", a: "We choreograph sangeet, first dances, and full family routines with rehearsals on your timeline." },
  { q: "How do trial classes work?", a: "Book a free trial via our form. Our advisors will reach out within 24 hours to confirm your slot." },
];

export const HERO_SLIDES = [
  {
    image: "https://images.pexels.com/photos/3022420/pexels-photo-3022420.jpeg",
    eyebrow: "International Dance Academy",
    title: "Rise. Move. Perform.",
    subtitle: "Join Phoenix Dance Academy — a vibrant dance community with branches in India, USA, and Canada.",
  },
  {
    image: "https://images.unsplash.com/photo-1504647164485-1d91e1d0a112?w=2000",
    eyebrow: "Train. Compete. Shine.",
    title: "Where Movement Becomes Mastery.",
    subtitle: "World-class faculty, structured syllabus, and global performance opportunities — all under one roof.",
  },
  {
    image: "https://images.pexels.com/photos/36763080/pexels-photo-36763080.jpeg",
    eyebrow: "Hip-Hop · Contemporary · Bollywood",
    title: "Find Your Style. Own Your Stage.",
    subtitle: "From your first step to your first standing ovation — Phoenix walks with you.",
  },
];

export const MILESTONES = [
  { year: "2014", title: "Phoenix India founded", text: "Manikandan Gopinath opens the flagship Phoenix studio in MKB Nagar, Chennai with just 3 students." },
  { year: "2019", title: "Vijay TV — Dancing Super Stars", text: "Jill Jung Juck Team featured as Finalists with Manikandan Gopinath as Choreographer on Vijay TV's Dancing Super Stars." },
  { year: "2021", title: "Phoenix USA launches", text: "Gowri Sathish founds the Sacramento branch with a faculty of 12 international choreographers." },
  { year: "2022", title: "Phoenix Canada opens", text: "Sandhya Vijayakumar launches Phoenix Kitchener, completing our three-country footprint." },
  { year: "2024", title: "10,000+ students trained", text: "Phoenix celebrates a decade of training, performing, and inspiring across continents." },
  { year: "2026", title: "Phoenix Live Tour", text: "Our flagship student showcase tour announces stops in Chennai, Sacramento, and Kitchener." },
];

export const VALUES = [
  { title: "Passion", text: "We move because we love it. Energy is non-negotiable." },
  { title: "Discipline", text: "Greatness is a daily practice. We train with intention." },
  { title: "Creativity", text: "Every dancer brings a voice. We help you find yours." },
  { title: "Confidence", text: "The studio is a safe space to grow loud, brave, and bold." },
  { title: "Community", text: "Phoenix is a family that spans cities, languages, and time zones." },
];

export const AWARDS = [
  // 2026
  {
    year: "2026",
    title: "USA Got Talent 2026 — Title Winner",
    org: "USA Got Talent · Judges: Kala Master & Meena (Actress)",
    branch: "Sacramento, USA",
    category: "Title Win",
    description: "Phoenix USA team crowned title winners at USA Got Talent 2026, judged by industry icons Kala Master and actress Meena.",
  },
  {
    year: "2026",
    title: "Sargolsav Dance Competition 2026 — Title Winner",
    org: "Sargolsav Dance Competition",
    branch: "Sacramento, USA",
    category: "Title Win",
    description: "Phoenix USA crew took home the Sargolsav Dance Competition 2026 title in California.",
  },
  {
    year: "2026",
    title: "Phoenix USA Presents Kala Master Dance Workshop 2026",
    org: "Phoenix Dance Academy USA",
    branch: "Sacramento, USA",
    category: "Workshop",
    description: "Phoenix USA hosted a flagship workshop with celebrated choreographer Kala Master in 2026.",
  },
  {
    year: "2026",
    title: "TAGS 2026 — Telugu Association of Sacramento",
    org: "Telugu Association of Sacramento",
    branch: "Sacramento, USA",
    category: "Performance",
    description: "Phoenix Dance Academy USA represented at TAGS 2026, one of California's most-watched cultural showcases.",
  },
  {
    year: "2026",
    title: "STM 2026 — Sacramento Tamil Mandram",
    org: "Sacramento Tamil Mandram",
    branch: "Sacramento, USA",
    category: "Performance",
    description: "Featured Phoenix performance at the Sacramento Tamil Mandram annual celebration 2026.",
  },
  {
    year: "2026",
    title: "Pongal Celebrations — Tamil Cultural Association, Waterloo",
    org: "Tamil Cultural Association of Waterloo",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada teams performed at the Tamil Cultural Association Waterloo Pongal celebrations 2026.",
  },
  {
    year: "2026",
    title: "Thaipoosam Festival — Waterloo Murugan Temple",
    org: "Waterloo Murugan Temple",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada showcase at the Thaipoosam Festival hosted by the Waterloo Murugan Temple.",
  },
  {
    year: "2026",
    title: "The Grand Festival 2026 — Featured Performance",
    org: "The Grand Festival",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada returned to one of Ontario's most prominent community festivals.",
  },
  {
    year: "2026",
    title: "Carassauga 2026 — Festival of Cultures",
    org: "Carassauga · Festival of Cultures, Mississauga",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada represented the Indian community at Carassauga 2026, Canada's largest multicultural festival.",
  },

  // 2025
  {
    year: "2025",
    title: "Best Team Award — Sacramento Tamil Mandram",
    org: "Sacramento Tamil Mandram",
    branch: "Sacramento, USA",
    category: "Title Win",
    description: "Phoenix USA awarded Best Team at the 2025 Sacramento Tamil Mandram annual cultural night.",
  },
  {
    year: "2025",
    title: "Multiple wins at the Gala Competition (judged by Sandy Master)",
    org: "Gala Dance Competition",
    branch: "Kitchener, Canada",
    category: "Title Win",
    description: "Several Phoenix Canada teams trained by Manikandan Gopinath placed at the Gala Dance Competition, judged by Sandy Master.",
  },
  {
    year: "2025",
    title: "Gala Competition — 1st Prize · Dual Round",
    org: "Gala Dance Competition · Kitchener",
    branch: "Kitchener, Canada",
    category: "Title Win",
    description: "Phoenix Canada students secured 1st Prize in the Dual Round at the Gala Competition 2025.",
  },
  {
    year: "2025",
    title: "Gala Competition — 2nd Prize · 5–8 Years Zone",
    org: "Gala Dance Competition · Kitchener",
    branch: "Kitchener, Canada",
    category: "Title Win",
    description: "Phoenix Canada's young dancers placed 2nd in the 5–8 years age zone at the Gala Competition 2025.",
  },
  {
    year: "2025",
    title: "TCA Thai Pongal Thiruvizha 2025",
    org: "Tamil Cultural Association · Waterloo",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada performed at TCA's flagship Thai Pongal Thiruvizha 2025.",
  },
  {
    year: "2025",
    title: "Thai Poosam 2025 — Waterloo Murugan Temple",
    org: "Waterloo Murugan Temple",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Featured Phoenix Canada showcase at Waterloo Murugan Temple's Thai Poosam celebrations 2025.",
  },
  {
    year: "2025",
    title: "KWC Bengali Event 2025",
    org: "Kitchener–Waterloo Bengali Community",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada represented Indo-Canadian dance at the KWC Bengali community event 2025.",
  },
  {
    year: "2025",
    title: "Gujarati Diwali Event 2025",
    org: "Gujarati Samaj · Waterloo Region",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada performed at the Gujarati Diwali celebrations 2025.",
  },
  {
    year: "2025",
    title: "Punjabi Mela 2025",
    org: "Punjabi Mela · Waterloo Region",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada represented at the annual Punjabi Mela 2025.",
  },
  {
    year: "2025",
    title: "Grand River Kannada Diwali Event 2025",
    org: "Grand River Kannada Sangha",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada showcase at the Grand River Kannada Sangha's Diwali celebrations 2025.",
  },
  {
    year: "2025",
    title: "Colors of India 2025",
    org: "Colors of India · Cultural Showcase",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada performance featured at Colors of India 2025.",
  },
  {
    year: "2025",
    title: "India's Republic Day Event 2025",
    org: "Indian Community of Waterloo Region",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada represented at the Republic Day cultural celebrations 2025.",
  },
  {
    year: "2025",
    title: "Kalai Vizha 2025",
    org: "Kalai Vizha · Cultural Festival",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada featured performance at Kalai Vizha 2025.",
  },
  {
    year: "2025",
    title: "Indian Vibes 2025",
    org: "Indian Vibes Cultural Show",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada showcase at Indian Vibes 2025.",
  },
  {
    year: "2025",
    title: "The Grand Festival 2025 — Featured Performance",
    org: "The Grand Festival",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada delivered standout performances at one of Ontario's most prominent community festivals.",
  },
  {
    year: "2025",
    title: "The Professionals — Annual Showcase",
    org: "Phoenix Dance Academy India",
    branch: "Chennai, India",
    category: "Production",
    description: "Manikandan Gopinath led choreography for Phoenix India's flagship annual event 'The Professionals', performed before a large audience and notable celebrities.",
  },
  {
    year: "2025",
    title: "Indian Association of Sacramento — Cultural Show",
    org: "Indian Association of Sacramento",
    branch: "Sacramento, USA",
    category: "Performance",
    description: "Phoenix USA represented at the Indian Association of Sacramento's flagship cultural show — one of California's most recognised diaspora events.",
  },
  {
    year: "2025",
    title: "Telugu Association of Sacramento — Top Performance",
    org: "Telugu Association of Sacramento",
    branch: "Sacramento, USA",
    category: "Performance",
    description: "Phoenix USA performance ranked among the top showcases of the 2025 TAGS celebration.",
  },
  {
    year: "2025",
    title: "Album Choreography — Dad's Princess",
    org: "Album · Dad's Princess (2025)",
    branch: "Chennai, India",
    category: "Production",
    description: "Manikandan Gopinath choreographed for the 2025 album 'Dad's Princess'.",
  },

  // 2024
  {
    year: "2024",
    title: "Star Performer — FETNA 36th Annual Convention",
    org: "Federation of Tamil Sangams of North America (FETNA)",
    branch: "Sacramento, USA",
    category: "Title Win",
    description: "Adjudged Star Performer at the FETNA 36th Annual Convention's Star Performer's Nite — also invited as Judge for the event.",
  },
  {
    year: "2024",
    title: "FETNA Grand Team — Thonmai Thamizharin Thanmai",
    org: "FETNA 36th Annual Convention",
    branch: "Sacramento, USA",
    category: "Production",
    description: "Trained two grand dance teams of 50+ students for FETNA 2024. Themed 'Thonmai Thamizharin Thanmai', featuring 'Ponniyin Selvan' and 'Velu Nachiyar' — celebrated across California.",
  },
  {
    year: "2024",
    title: "Canada's Thumakda — 1st Prize",
    org: "Canada's Thumakda Dance Competition",
    branch: "Kitchener, Canada",
    category: "Title Win",
    description: "Phoenix Canada students took home 1st Prize at Canada's Thumakda 2024.",
  },
  {
    year: "2024",
    title: "TCA Thai Pongal Thiruvizha 2024",
    org: "Tamil Cultural Association · Waterloo",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada featured performance at TCA's Thai Pongal Thiruvizha 2024.",
  },
  {
    year: "2024",
    title: "Thai Poosam 2024 — Waterloo Murugan Temple",
    org: "Waterloo Murugan Temple",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada showcase at Waterloo Murugan Temple's Thai Poosam 2024.",
  },
  {
    year: "2024",
    title: "Sathya Narayana Temple Kandashasti Kondattam 2024",
    org: "Sathya Narayana Temple",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada performed at Sathya Narayana Temple's Kandashasti Kondattam 2024.",
  },
  {
    year: "2024",
    title: "Gujarati Diwali Event 2024",
    org: "Gujarati Samaj · Waterloo Region",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada showcase at the Gujarati Diwali celebrations 2024.",
  },
  {
    year: "2024",
    title: "Punjabi Mela 2024",
    org: "Punjabi Mela · Waterloo Region",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada featured at the Punjabi Mela 2024.",
  },
  {
    year: "2024",
    title: "Yukthi Event 2024",
    org: "Yukthi Cultural Event",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada featured at the Yukthi cultural event 2024.",
  },
  {
    year: "2024",
    title: "Grand River Kannada Ugadhi Event 2024",
    org: "Grand River Kannada Sangha",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada showcase at the Grand River Kannada Ugadhi celebrations 2024.",
  },
  {
    year: "2024",
    title: "TCA Chithirai Thiruvizha 2024",
    org: "Tamil Cultural Association · Waterloo",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada performance at TCA's Chithirai Thiruvizha 2024.",
  },

  // 2023
  {
    year: "2023",
    title: "Punjabi Mela 2023",
    org: "Punjabi Mela · Waterloo Region",
    branch: "Kitchener, Canada",
    category: "Performance",
    description: "Phoenix Canada's debut representation at the Punjabi Mela 2023.",
  },
  {
    year: "2023",
    title: "Independence Day Performance — Indian Association of Sacramento",
    org: "Indian Association of Sacramento",
    branch: "Sacramento, USA",
    category: "Performance",
    description: "'Ponniyin Selvan' performance specially requested for the Indian Association of Sacramento's Independence Day celebrations.",
  },

  // 2019 — Vijay TV
  {
    year: "2019",
    title: "Dancing Super Stars (Jill Jung Juck Team)",
    org: "Vijay TV",
    branch: "Chennai, India",
    category: "Television",
    description: "Finalist · Choreographer — Manikandan Gopinath choreographed the Jill Jung Juck Team to the finals of Vijay TV's Dancing Super Stars.",
  },

  // 2017 — Vijay TV
  {
    year: "2017",
    title: "Kings of Dance",
    org: "Vijay TV",
    branch: "Chennai, India",
    category: "Television",
    description: "Semi-Finalist & Choreographer on Vijay TV's Kings of Dance — one of South India's most-watched dance reality shows.",
  },

  // 2013 — Vijay TV
  {
    year: "2013",
    title: "Ungalil Yaar Adutha Prabhudeva",
    org: "Vijay TV",
    branch: "Chennai, India",
    category: "Television",
    description: "Top Contestant on Vijay TV's flagship dance hunt 'Ungalil Yaar Adutha Prabhudeva' — an early platform that put Manikandan Gopinath on the national dance map.",
  },
];

export const AWARD_STATS = [
  { value: 70, suffix: "+", label: "Awards & Honours" },
  { value: 15, suffix: "+", label: "Title Wins" },
  { value: 8, suffix: "+", label: "International Productions" },
  { value: 3, suffix: "", label: "Countries Recognised In" },
];

